import { LayoutType, withLayout } from 'hocs/with-layout';

import { NotFound } from './not-found';

const WrappedNotFound = withLayout(LayoutType.WithOldNavAndFooter, NotFound);

export { WrappedNotFound as NotFound };
